import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './InfoView.m.sass';
import { Form, Input } from '../../../../components/Form';
import Button from '../../../../components/Button';
import Avatar from 'components/Avatar';
import FileButton from 'components/FileButton';
var InfoView = function InfoView(_ref) {
  var state = _ref.state;
  var teamMember = state.sessionStore.teamMembers.find(function (x) {
    return x.teamId === state.team.id;
  });
  var canEdit = state.sessionStore.member.hasPermission('ADMIN_TEAM_BILLING_MANAGE') || teamMember && teamMember.isTeamOwner || state.allowEdit;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(FileButton, {
    onChange: function onChange(files) {
      return state.infoViewState.uploadPicture(files[0]);
    },
    accept: ".png,.jpg,.jpeg",
    className: styles.fileButton
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: 128,
    className: "profile-editor-avatar",
    url: state.infoViewState.picture
  })), /*#__PURE__*/React.createElement(Form, {
    onSubmit: state.infoViewState.saveInfo
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Team name",
    field: "name",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Team slug",
    readOnly: true,
    disabled: true,
    field: "slug",
    model: state.infoViewState
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Team owner",
    readOnly: true,
    disabled: true,
    value: state.team.owner.member.displayName
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Team Purpose",
    field: "teamPurpose",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Team Details"), /*#__PURE__*/React.createElement("div", {
    className: styles.workArea
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Street Address",
    field: "streetAddress",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement(Input, {
    label: "City",
    field: "city",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement(Input, {
    label: "State",
    field: "state",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Zip Code",
    field: "zipCode",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }), /*#__PURE__*/React.createElement(Input, {
    label: "Country",
    field: "country",
    model: state.infoViewState,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.button,
    submit: true,
    type: "primary",
    loading: state.infoViewState.saveInfo.pending,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }, "Save"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return state.infoViewState.deleteTeam();
    },
    type: "danger",
    loading: state.infoViewState.saveInfo.pending,
    disabled: state.infoViewState.saveInfo.pending || !canEdit
  }, "Delete Team"))));
};
export default observer(InfoView);
//# sourceMappingURL=index.js.map
